import { assertNever } from '@kofno/piper';
import { action, computed, makeObservable, observable } from 'mobx';
import { error } from '../../../../ErrorHandling';
import { TPlainTextKey } from '../../../../Translations';
import GroupParticipantsStore from '../GroupParticipantsStore/Store';
import { GroupParticipantsOptionsResource, State, ready, waiting } from './Types';

class GroupOptionsStore {
  @observable private _state: State = waiting();

  readonly groupParticipantsStore: GroupParticipantsStore;

  constructor(groupParticipantsStore: GroupParticipantsStore) {
    makeObservable(this);
    this.groupParticipantsStore = groupParticipantsStore;
  }

  @action
  ready = (resource: GroupParticipantsOptionsResource) => {
    this._state = ready(resource);
  };

  @action
  error = (msg: TPlainTextKey) => {
    this._state = error(msg);
  };

  @computed
  get state(): State {
    switch (this._state.kind) {
      case 'waiting':
        return this.groupParticipantsStore.optionsState;
      case 'ready':
      case 'error':
      case 'loading':
        return this._state;
      default:
        return assertNever(this._state);
    }
  }
}

export default GroupOptionsStore;
